var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vld-parent"},[_c('loading',{attrs:{"active":_vm.isLoading,"loader":_vm.loaderType,"color":_vm.color,"height":128,"width":128,"is-full-page":true},on:{"update:active":function($event){_vm.isLoading=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }